import React from 'react';
import '../styles/About.css';

function About({ language }) {
  return (
    <section id="about" className="section bg-light">
      <div className="container">
        <h2>
          <span lang="en">About Nexofortis</span>
          <span lang="fr">À propos de Nexofortis</span>
        </h2>

        <p className="lead">
          <span lang="en">
            Founded in June 2025, Nexofortis specializes in technical system integration with MuleSoft and Workato. 
            We deliver cutting-edge integration solutions to transform your digital operations.
          </span>
          <span lang="fr">
            Fondée en juin 2025, Nexofortis se spécialise dans l'intégration de systèmes techniques avec MuleSoft et Workato. 
            Nous fournissons des solutions d'intégration de pointe pour transformer vos opérations digitales.
          </span>
        </p>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">2025</div>
            <p className="stat-label">
              <span lang="en">Founded to deliver high-quality integrations with expert precision</span>
              <span lang="fr">Fondée pour fournir des intégrations de haute qualité avec une précision experte</span>
            </p>
          </div>

          <div className="stat-card">
            <div className="stat-number">10+</div>
            <p className="stat-label">
              <span lang="en">Years of combined experience in advanced multi-system integration</span>
              <span lang="fr">Années d'expérience combinée en intégration multisystèmes avancée</span>
            </p>
          </div>

          <div className="stat-card">
            <div className="stat-number">100%</div>
            <p className="stat-label">
              <span lang="en">MuleSoft & Workato Specialists, Focused solely on integration & automation</span>
              <span lang="fr">Spécialistes MuleSoft & Workato, exclusivement dédiés à l'intégration et à l'automatisation</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
